var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560 32H176C149.492 32 128 53.49 128 80V81.311L340.469 246.281C356.664 258.877 379.336 258.877 395.531 246.281L608 81.311V80C608 53.49 586.508 32 560 32ZM368 288C351.469 288 334.938 282.516 320.844 271.531L128 121.297V336C128 362.51 149.492 384 176 384H560C586.508 384 608 362.51 608 336V121.297L415.156 271.531C401.062 282.516 384.531 288 368 288ZM80 400V96C53.49 96 32 117.492 32 144V416C32 451.346 60.654 480 96 480H464C490.51 480 512 458.508 512 432H112C94.326 432 80 417.672 80 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopes);
export default __webpack_public_path__ + "static/media/envelopes.8f3daa91bea4b9afabcce949d6e66b89.svg";
export { ForwardRef as ReactComponent };